(function () {
  var MQ = '(max-width: 767px)';
  var SELECTOR = '#shopify-section-footer .footer__column--link-list';
  var bound = false;

  function isMobile() {
    return window.matchMedia && window.matchMedia(MQ).matches;
  }

  function panelOf(title) {
    var el = title.nextElementSibling;
    while (el && el.className.indexOf('footer__column__content') === -1) {
      el = el.nextElementSibling;
    }
    return el;
  }

  function setState(title, panel, open) {
    title.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      panel.removeAttribute('hidden');
      title.classList.add('is-open');
    } else {
      panel.setAttribute('hidden', '');
      title.classList.remove('is-open');
    }
  }

  function enable(col, i) {
    var title = col.querySelector('.footer__column__title');
    var panel = title && panelOf(title);
    if (!title || !panel) return;

    if (!panel.id) panel.id = 'footer-panel-' + i;
    title.setAttribute('role', 'button');
    title.setAttribute('tabindex', '0');
    title.setAttribute('aria-controls', panel.id);
    title.classList.add('ftr-accordion__trigger');
    setState(title, panel, false);

    function toggle(e) {
      if (e) e.preventDefault();
      var open = title.getAttribute('aria-expanded') === 'true';
      setState(title, panel, !open);
    }

    title.addEventListener('click', toggle);
    title.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.keyCode === 13 || e.keyCode === 32) toggle(e);
    });
  }

  function disable(col) {
    var title = col.querySelector('.footer__column__title');
    var panel = title && panelOf(title);
    if (!title || !panel) return;
    title.removeAttribute('role');
    title.removeAttribute('tabindex');
    title.removeAttribute('aria-expanded');
    title.removeAttribute('aria-controls');
    title.classList.remove('ftr-accordion__trigger', 'is-open');
    panel.removeAttribute('hidden');
  }

  function sync() {
    var cols = document.querySelectorAll(SELECTOR);
    if (!cols.length) return;
    var i;
    if (isMobile()) {
      if (bound) return;
      bound = true;
      for (i = 0; i < cols.length; i++) enable(cols[i], i);
    } else if (bound) {
      bound = false;
      for (i = 0; i < cols.length; i++) disable(cols[i]);
    }
  }

  function init() {
    sync();
    if (window.matchMedia) {
      var mql = window.matchMedia(MQ);
      if (mql.addEventListener) {
        mql.addEventListener('change', sync);
      } else if (mql.addListener) {
        mql.addListener(sync);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.detail && e.detail.sectionId === 'footer') {
      bound = false;
      sync();
    }
  });
})();
